import { Divider, Drawer, Tab, Tabs, Theme, useMediaQuery } from "@material-ui/core";
import { useAccessControl, useAuth, useVerifyPermission } from "@airborne/react-admin";
import classnames from "classnames";
import React, { useEffect, useState } from "react";
import { CreateButton, ExportButton, Filter, TextInput, TopToolbar } from "react-admin";
import { useHistory } from "react-router-dom";
import { RemarkTypes } from "../../../../../src/Enums/RemarkTypes";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import { useAppDataProvider } from "../../../../dataprovider";
import { FilterInputType } from "../../../../Enums/FilterTypes";
import { RequestListGroupType } from "../../../../Enums/RequestListGroupType";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { getStatusListByGroup } from "../../../../Helper/RequestStatusGroupHelper";
// import RequestWorkFlow from '../../../RequestWorkFlow/RequestWorkFlow'
import { SourceRequestOrder } from "../../Constant/Source";
import RequestOrderNotes from "../RequestOrderNotes";
import { RequestOrderDataGrid } from "./RequestOrderDataGrid";
import { useStyles } from "./styles";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";

export const RequestOrderList = (props: any) => {
  useVerifyPermission("customroutes", "requestorders.list.read");
  const [activeTab, setActiveTab] = useState(RequestListGroupType.InProgress);
  const [tabs, setTabs] = useState<any[]>([]);
  const [requestRemark, setRequestRemark] = useState<any>({});
  const [isMatchCreate, setIsMatchCreate] = useState(false);
  const [inProgressStatusList, setInProgressStatusList] = useState<any>([]);
  const [remark, setRemark] = useState<string>();
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));
  const classes = useStyles();
  const history = useHistory();
  const dataProvider = useAppDataProvider();
  const [openWorkflow, setOpenWorkflow] = React.useState(false);
  const [workflowRequestId, setWorkflowRequestId] = React.useState(false);
  const { user } = useAuth();
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestOrder);

  const _requestStatusFilterSort = [
    { sort: 0, requestStatus: RequestStatus.CancellationRepairPeriod },
    { sort: 1, requestStatus: RequestStatus.PlaneLanded },
    { sort: 2, requestStatus: RequestStatus.PoolUserAccept },
    { sort: 3, requestStatus: RequestStatus.Shipped },
  ];

  useEffect(() => {
    dataProvider
      .getList("requeststatusinfo/reference", {
        pagination: { page: 1, perPage: 5 },
        sort: { field: "id", order: "ASC" },
        filter: {
          [`id = ${RequestStatus.InProgress} || id =  ${RequestStatus.WaitingTTApproval} || id =  ${RequestStatus.OpenNotSet}`]:
            "test",
        },
      })
      .then(response => {
        let tab = response.data.map(item => ({
          value: item.id,
          label: item.displayName,
          count: item.totalCount,
        }));
        setTabs(tab);
      })
      .catch(error => {
        console.log(error);
      });

    const getStatus = () => {
      getStatusListByGroup(RequestListGroupType.InProgress).then(result => {
        let sortedData: any[] = [];
        result.forEach(element => {
          let dummyData = _requestStatusFilterSort.find(item => item.requestStatus === Number(element.requestStatus));
          element["sort"] = dummyData ? dummyData.sort : 1000;
          sortedData.push(element);
        });
        setInProgressStatusList(sortedData.sort((a, b) => a.sort - b.sort));
      });
    };
    getStatus();
    return () => {
      if (history.location.pathname === "/requestorders/requestorders/create") {
        history.replace("/requestorders/create");
      }
    };
  }, []);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const ExportToExcel = data => {
    ExcelExport(
      [
        {
          header: "Ref No",
          key: "Ref No",
        },
        {
          header: "Customer",
          key: "Customer",
        },
        {
          header: "Airport Code",
          key: "Airport Code",
        },
        {
          header: "Pn",
          key: "Pn",
        },
        {
          header: "Description",
          key: "Description",
        },
        {
          header: "Workshop",
          key: "Workshop",
        },
        {
          header: "Requested Delivery Date",
          key: "Requested Delivery Date",
        },
        {
          header: "Wh Count",
          key: "Wh Count",
        },
        {
          header: "Res Count",
          key: "Res Count",
        },
        {
          header: "Alt Pn Count",
          key: "Alt Pn Count",
        },
        {
          header: "Wo Count",
          key: "Wo Count",
        },
        {
          header: "Ro Count",
          key: "Ro Count",
        },
        {
          header: "Po/Ex Count",
          key: "Po/Ex Count",
        },
        {
          header: "Customer PO",
          key: "Customer PO",
        },
        {
          header: "TT WO",
          key: "TT WO",
        },
        {
          header: "TT RO",
          key: "TT RO",
        },
        {
          header: "Current PBH Note",
          key: "Current PBH Note",
        },
        {
          header: "Status",
          key: "Status",
        },
      ],
      data.map(v => [
        v.refNo,
        v.ownerCode,
        v.airportCode,
        v.customerRequestComponent,
        v.componentDescription,
        v.workshop,
        v.requestedDeliveryDate != null ? v.requestedDeliveryDate : "",
        v.whCount,
        v.resCount,
        v.altPnCount,
        v.woCount,
        v.roCount,
        v.poExCount,
        v.customerPo,
        v.ttWo,
        v.ttRo,
        v.currentPbhNote,
        v.requestStatusText,
      ]),
      "Request List"
    );
  };

  const RequestOrderFilter = props => (
    <Filter {...props}>
      <TextInput label="Ref No" source="refNo__contains" alwaysOn />
    </Filter>
  );

  const ListChild = props => {
    return (
      <RequestOrderDataGrid
        {...props}
        setActiveTab={setActiveTab}
        onCreateRemarks={onCreateRemarks}
        isXSmall={isXSmall}
        requestStatus={activeTab}
        requestRemark={requestRemark}
        remark={remark}
        setRemark={setRemark}
        handleOpenWorkFlow={handleOpenWorkFlow}
      />
    );
  };

  const handleClose = value => {
    setIsMatchCreate(false);
    //if (typeof value == 'string') setRemark(value)
  };
  const onCreateRemarks = record => {
    setIsMatchCreate(true);
    setRequestRemark(record);
  };

  const ListActions = props => (
    <TopToolbar {...props}>
      {user?.isCustomer && canCreate && (
        <CreateButton basePath={props.basePath} icon={props.icon} label={props.label} />
      )}
      <ExportButton
        resource={props.resource}
        sort={props.currentSort}
        filterValues={props.filterValues}
        maxResults={10000}
      />
    </TopToolbar>
  );
  const handleCloseWorkFlow = () => {
    setOpenWorkflow(false);
  };
  const handleOpenWorkFlow = Id => {
    setOpenWorkflow(true);
    setWorkflowRequestId(Id);
  };
  return (
    <>
      <Tabs
        variant={"fullWidth"}
        centered
        value={activeTab}
        indicatorColor="primary"
        onChange={handleChange}
        className={classnames({
          [classes.listWithDrawer]: isMatchCreate,
        })}
      >
        {tabs.map((tab: any) => {
          return (
            <Tab
              key={tab.value + "tab"}
              label={`${tab.label} (${tab.count >= 0 ? tab.count : "..."})`}
              value={tab.value}
            />
          );
        })}
      </Tabs>
      <Divider />
      <PoolList
        {...props}
        resource={SourceRequestOrder}
        basePath={SourceRequestOrder}
        className={classnames(classes.list, {
          [classes.listWithDrawer]: isMatchCreate,
        })}
        title={"Request Order List"}
        filterDefaultValues={{
          requestStatus__eq: RequestListGroupType.InProgress,
          isWhInfo__eq: true,
        }}
        actions={<ListActions />}
        sort={{ field: "requestedDeliveryDate", order: "ASC" }}
        perPage={10}
        exporter={ExportToExcel}
        // filters={<RequestOrderFilter />}
        emptyWhileLoading={true}
        filters={
          activeTab == RequestListGroupType.InProgress ? (
            <FilterToolbar
              dataSource={[
                {
                  source: "refNo",
                  inputType: FilterInputType.Text,
                  label: "Ref No",
                },
                {
                  source: "requestStatus",
                  inputType: FilterInputType.Select,
                  label: "Status",
                  resettable: false,
                  optionText: "displayName",
                  optionValue: "requestStatus",
                  style: { width: "250px" },
                  choices: [...inProgressStatusList],
                  allowEmpty: true,
                  emptyValue: RequestListGroupType.InProgress,
                  emptyText: "All",
                },
                {
                  source: "ownerCode",
                  inputType: FilterInputType.Text,
                  label: "Customer",
                },
                {
                  source: "airportCode",
                  inputType: FilterInputType.Text,
                  label: "Destination",
                },
                {
                  source: "customerRequestComponent",
                  inputType: FilterInputType.Text,
                  label: "Pn",
                },
                {
                  source: "componentDescription",
                  inputType: FilterInputType.Text,
                  label: "Description",
                },
                {
                  source: "customerPo",
                  inputType: FilterInputType.Text,
                  label: "Customer Po",
                },
                {
                  style: { width: "250px" },
                  source: "requestedDeliveryDate",
                  inputType: FilterInputType.Date,
                  label: "Requested Delivery Date",
                },
                {
                  source: "isLocalRepair",
                  inputType: FilterInputType.Select,
                  label: "Local Repair",
                  choices: [
                    { id: true, name: "Yes" },
                    { id: false, name: "No" },
                  ],
                  resettable: true,
                },
              ]}
            />
          ) : (
            <RequestOrderFilter />
          )
        }
      >
        <ListChild />
      </PoolList>
      {/* <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={openWorkflow}
        onClose={handleCloseWorkFlow}
        aria-labelledby="max-width-dialog-title"
      >
        <div style={{ height: 1071 }}>
          <RequestWorkFlow readOnly requestId={workflowRequestId} />
        </div>
      </Dialog> */}
      <Drawer
        variant="persistent"
        open={isMatchCreate}
        anchor="right"
        onClose={handleClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {isMatchCreate ? (
          <RequestOrderNotes
            onCancel={handleClose}
            request={requestRemark}
            resource="requestremarks"
            basePath="requestremarks"
            remarkType={RemarkTypes.PbhNote}
          />
        ) : null}
      </Drawer>
    </>
  );
};

export default RequestOrderList;
